var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-podcast" }, [
    _c(
      "div",
      {
        class:
          _vm.item.Url == "" ? "card-content" : "card-content podcast-content"
      },
      [
        _c(
          "div",
          { staticClass: "card-content-wrap" },
          [
            _c(
              _vm.item.Url != "" ? "a" : "div",
              {
                tag: "component",
                class:
                  _vm.item.Url != ""
                    ? "card-content-wrap-inner"
                    : "card-content-wrap-inner",
                attrs: {
                  href:
                    _vm.item.Url != "" ? _vm.item.Url.replace("~/", "/") : null,
                  target:
                    _vm.item.Url != ""
                      ? _vm.item.Url.indexOf("/") == 0
                        ? "_self"
                        : "_blank"
                      : null
                }
              },
              [
                _vm.item.Eyebrow
                  ? _c("div", { staticClass: "card-content-wrap-eyebrow" }, [
                      _c("p", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.item.Eyebrow) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.Image
                  ? _c("div", { staticClass: "card-content-wrap-image" }, [
                      _c("img", {
                        attrs: { src: _vm.item.Image, alt: _vm.item.Alt }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("h2", { staticClass: "card-content-wrap-title" }, [
                  _vm._v(_vm._s(_vm.item.Title))
                ]),
                _vm._v(" "),
                _vm.displaySummary
                  ? _c(
                      "div",
                      { staticClass: "card-content-wrap-description" },
                      [
                        _vm.displayDate
                          ? _c("p", { staticClass: "pos-left mr-md-1" }, [
                              _c("em", [
                                _vm._v(
                                  _vm._s(_vm.formatDate(_vm.item.Date)) + " - "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.item.Summary) }
                        })
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.item.Media
          ? _c("div", {
              staticClass: "card-content-media",
              domProps: { innerHTML: _vm._s(_vm.item.Media) }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.displaySummary
          ? _c("div", { staticClass: "card-content-footer" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6 card-content-footer-date" }, [
                  _vm.displayDate
                    ? _c("p", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.formatDate(_vm.item.Date)) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 card-content-footer-cta" }, [
                  _vm.item.Url
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.item.Url != "" ? _vm.item.Url : null,
                            target:
                              _vm.item.Url != ""
                                ? _vm.item.Url.indexOf("/") == 0
                                  ? "_self"
                                  : "_blank"
                                : null
                          }
                        },
                        [_vm._v("Episode Details")]
                      )
                    : _vm._e()
                ])
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }